import { ContainerStyled } from "./container.styles"
import { ContainerProps } from "./types"

const Container: React.FC<ContainerProps> = ({ children }) => {
    return (
        <ContainerStyled>
            {children}
        </ContainerStyled>
    )
}

export default Container